<script>
  export default {
    name: 'VActionBar',
    props: {
      title: {
        type: String,
        default: ''
      },
      prefixActions: {
        type: Array,
        default: () => ([])
      },
      actions: {
        type: Array,
        default: () => ([])
      }
    },

    methods: {
      emit(action) {
        this.$emit('click', action)
      }
    }
  }
</script>

<template>
  <VSystemBar color="transparent">
    <template v-for="(action, index) in prefixActions">
      <VDivider v-if="action.divider" :key="index" class="mx-2" vertical/>
      <VTooltip v-else-if="!action.hidden" :key="action.name" bottom :disabled="!action.label">
        <template v-slot:activator="{ on }">
          <VBtn icon x-small class="mx-1" :disabled="action.disabled" v-on="on" @click.left="emit(action)">
            <VIcon :color="action.color" small class="mr-0">{{ action.icon }}</VIcon>
          </VBtn>
        </template>
        <span v-text="action.label"/>
      </VTooltip>
    </template>
    <div v-if="title" v-text="title"/>
    <VSpacer/>
    <template v-for="(action, index) in actions">
      <VDivider v-if="action.divider" :key="index" class="mx-2" vertical/>
      <VTooltip v-else-if="!action.hidden" :key="action.name" bottom :disabled="!action.label">
        <template v-slot:activator="{ on }">
          <VBtn icon x-small class="mx-1" :disabled="action.disabled" v-on="on" @click.left="emit(action)">
            <VIcon :color="action.color" small class="mr-0">{{ action.icon }}</VIcon>
          </VBtn>
        </template>
        <span v-text="action.label"/>
      </VTooltip>
    </template>
  </VSystemBar>
</template>
